import { motion, useReducedMotion } from "framer-motion";
import { cn } from "@rekati/utils";

const layoutSpring = { type: "spring" as const, bounce: 0.12, damping: 34, stiffness: 420 };

/**
 * Cult UI's Halo Progress without Base UI, restyled flat: a native progressbar role, the fill
 * a transform (not a width), and a sliding strip when the value is unknown.
 */
export function HaloProgress({
  value,
  max = 100,
  label,
  className,
}: {
  /** null: indeterminate. */
  value: number | null;
  max?: number;
  label: string;
  className?: string;
}) {
  const reduce = useReducedMotion();
  const pct = value === null ? 0 : Math.min(1, Math.max(0, value / max));
  return (
    <div
      role="progressbar"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={max}
      {...(value === null ? {} : { "aria-valuenow": value })}
      className={cn("relative h-2 w-full overflow-hidden rounded-full bg-muted", className)}
    >
      {value === null ? (
        <motion.span
          aria-hidden="true"
          className="absolute inset-y-0 left-0 w-2/5 rounded-full bg-volt"
          animate={reduce ? { x: "75%" } : { x: ["-100%", "260%"] }}
          transition={reduce ? { duration: 0 } : { duration: 1.15, ease: "easeInOut", repeat: Infinity }}
        />
      ) : (
        <motion.span
          aria-hidden="true"
          className="absolute inset-0 origin-left rounded-full bg-volt"
          initial={false}
          animate={{ scaleX: pct }}
          transition={reduce ? { duration: 0 } : layoutSpring}
        />
      )}
    </div>
  );
}
